import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

class SwitchableImageSlider {
	constructor(el) {
		this.root = el;

		this.initGroups();
		this.initSwitch();
		this.initText();
		this.initSlider();
	}

	initGroups() {
		this.groups = [
			this.root.querySelector('.js-switchableImageSliderGroup[data-group="1"]'),
			this.root.querySelector('.js-switchableImageSliderGroup[data-group="2"]'),
		];
	}

	initSwitch() {
		const button = this.root.querySelector('.js-switchableImageSliderSwitch');
		if (!button) return;

		button.addEventListener('click', ::this.onSwitchClick);
	}

	initText() {
		this.texts = Array.from(this.root.querySelectorAll('.js-switchableImageSliderText'));
	}

	initSlider() {
		this.imageAndCopySlider = new Swiper(
			this.root.querySelector('.js-switchableImageSliderImageAndCopyContainer'),
			{
				observer: true,
				observeParents: true,
				spaceBetween: 0,
				slidesPerView: 1,
				grabCursor: true,
				centeredSlides: true,
				loop: true,
				slideActiveClass: 'is-active',
				pagination: {
					el: this.root.querySelector('.js-switchableImageSliderImageAndCopyBulletList'),
					bulletElement: 'li',
					bulletClass: 'switchable-image-slider__bullet-item',
					bulletActiveClass: 'is-active',
					clickable: true,
				},

				navigation: {
					nextEl: this.root.querySelector('.js-switchableImageSliderImageAndCopyArrowNext'),
					prevEl: this.root.querySelector('.js-switchableImageSliderImageAndCopyArrowPrev'),
					disabledClass: 'is-disabled',
				},

				breakpoints: {
					1256: {
						spaceBetween: 30,
						slidesPerView: 3,
					},
				},

				on: {
					activeIndexChange: ::this.onActiveIndexChange,
				},
			}
		);

		new Swiper(this.root.querySelector('.js-switchableImageSliderImageAndLabelContainer'), {
			observer: true,
			observeParents: true,
			spaceBetween: 0,
			slidesPerView: 1,
			grabCursor: true,
			loop: true,
			slideActiveClass: 'is-active',

			navigation: {
				nextEl: this.root.querySelector('.js-switchableImageSliderImageAndLabelArrowNext'),
				prevEl: this.root.querySelector('.js-switchableImageSliderImageAndLabelArrowPrev'),
				disabledClass: 'is-disabled',
			},

			breakpoints: {
				575: {
					spaceBetween: 41,
					slidesPerView: 2,
				},
				768: {
					spaceBetween: 41,
					slidesPerView: 3,
				},
				1024: {
					spaceBetween: 35,
					slidesPerView: 4,
				},
				1256: {
					spaceBetween: 35,
					slidesPerView: 5,
				},
			},
		});
	}

	onSwitchClick(e) {
		e.currentTarget.classList.toggle('is-active');

		if (e.currentTarget.classList.contains('is-active')) {
			this.groups[0].classList.add('hidden');
			this.groups[1].classList.remove('hidden');

			if (this.imageAndCopySlider) {
				this.imageAndCopySlider.pagination.el.classList.add('hidden');
			}
		} else {
			this.groups[0].classList.remove('hidden');
			this.groups[1].classList.add('hidden');

			if (this.imageAndCopySlider) {
				this.imageAndCopySlider.pagination.el.classList.remove('hidden');
			}
		}
	}

	onActiveIndexChange(swiper) {
		const index = swiper.realIndex;
		this.texts.forEach(el => {
			el.classList.add('hidden');
		});

		const targetItem = this.root.querySelector(`[data-index="${index}"]`);
		if (targetItem) {
			targetItem.classList.remove('hidden');
		}
	}
}

Array.from(document.querySelectorAll('.js-switchableImageSlider')).forEach(
	el => new SwitchableImageSlider(el)
);
